import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneCurrentJobInformationSpecialization = createAsyncThunk(
  "GetOneCurrentJobInformationSpecialization/GetOneCurrentJobInformationSpecialization",
  async (parameters, { rejectWithValue }) => {
    try {

      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_CS_CurrentJobInformationSpecialization/GetOneWQ_NT_CS_CurrentJobInformationSpecialization",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateCurrentJobInformationSpecialization = createAsyncThunk(
  "UpdateCurrentJobInformationSpecialization/UpdateCurrentJobInformationSpecialization",
  async (parameters, { rejectWithValue }) => {
    try {
   
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_CS_CurrentJobInformationSpecialization/UpdateWQ_NT_CS_CurrentJobInformationSpecialization",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllAcademicRank = createAsyncThunk(
  "GetAllAcademicRank/GetAllAcademicRank",
  async (parameters, { rejectWithValue }) => {
    try {
   
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_ST_CS_AcademicRank/GetAllWQ_ST_CS_AcademicRank",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllCountry = createAsyncThunk(
  "GetAllCountry/GetAllCountry",
  async (parameters, { rejectWithValue }) => {
    try {

      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_ST_CS_Country/GetAllWQ_ST_CS_Country",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const CurrentJobInformationSpecialization = createSlice({
  name: "CurrentJobInformationSpecialization",
  initialState: {
    //------------- GetOneCurrentJobInformationSpecialization ---------------------
    CurrentJobInformationSpecialization: {},
    loadingCurrentJobInformationSpecialization: false,
    errorCurrentJobInformationSpecialization: null,
    //------------- Update CurrentJobInformationSpecialization ---------------------
    UpdateCurrentJobInformationSpecialization: {},
    loadingUpdateCurrentJobInformationSpecialization: false,
    errorUpdateCurrentJobInformationSpecialization: null,
    //-----------------------------------------------
    AcademicRank: [],
    loadingAcademicRank: false,
    errorAcademicRank: null,
    //--------------------------------------------
    Country: [],
    loadingCountry: false,
    errorCountry: null,
  },
  reducers: {
    SetCurrentJobInformationSpecializationState: (state, action) => {
      state.CurrentJobInformationSpecialization = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneCurrentJobInformationSpecialization.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingCurrentJobInformationSpecialization = true;
          state.CurrentJobInformationSpecialization = action.payload;
          state.errorCurrentJobInformationSpecialization = null;
        }
      )
      .addCase(
        GetOneCurrentJobInformationSpecialization.fulfilled,
        (state, action) => {
          state.loadingCurrentJobInformationSpecialization = false;
          state.CurrentJobInformationSpecialization = action.payload;
        }
      )
      .addCase(
        GetOneCurrentJobInformationSpecialization.rejected,
        (state, action) => {
          state.loadingCurrentJobInformationSpecialization = false;
          state.CurrentJobInformationSpecialization = action.payload;
        }
      );
    //------------- Update CurrentJobInformationSpecialization ---------------------
    builder
      .addCase(
        UpdateCurrentJobInformationSpecialization.pending,
        (state, action) => {
          state.loadingUpdateCurrentJobInformationSpecialization = true;
          state.UpdateCurrentJobInformationSpecialization = action.payload;
          state.errorUpdateCurrentJobInformationSpecialization = null;
        }
      )
      .addCase(
        UpdateCurrentJobInformationSpecialization.fulfilled,
        (state, action) => {
          state.loadingUpdateCurrentJobInformationSpecialization = false;
          state.UpdateCurrentJobInformationSpecialization = action.payload;
        }
      )
      .addCase(
        UpdateCurrentJobInformationSpecialization.rejected,
        (state, action) => {
          state.loadingUpdateCurrentJobInformationSpecialization = false;
          state.errorUpdateCurrentJobInformationSpecialization = action.payload;
        }
      );
    //------------- GetAllAcademicRank  ---------------------
    builder
      .addCase(GetAllAcademicRank.pending, (state, action) => {
        state.loadingAcademicRank = true;
        state.AcademicRank = action.payload;
        state.errorAcademicRank = null;
      })
      .addCase(GetAllAcademicRank.fulfilled, (state, action) => {
        state.loadingAcademicRank = false;
        state.AcademicRank = action.payload;
      })
      .addCase(GetAllAcademicRank.rejected, (state, action) => {
        state.loadingAcademicRank = false;
        state.errorAcademicRank = action.payload;
      });
    //------------- GetAllCountry ---------------------
    builder
      .addCase(GetAllCountry.pending, (state, action) => {
        state.loadingCountry = true;
        state.Country = action.payload;
        state.errorCountry = null;
      })
      .addCase(GetAllCountry.fulfilled, (state, action) => {
        state.loadingCountry = false;
        state.Country = action.payload;
      })
      .addCase(GetAllCountry.rejected, (state, action) => {
        state.loadingCountry = false;
        state.errorCountry = action.payload;
      });
  },
});
export const {SetCurrentJobInformationSpecializationState} = CurrentJobInformationSpecialization.actions;
export default CurrentJobInformationSpecialization.reducer;
